/**
 * base64ToFile
 * Converts a base64-encoded string into a File object,
 * typically used for rendering or uploading PDFs.
 *
 * @param base64String - The base64-encoded content of the file
 * @param fileName - Optional filename to assign (default: "file-preview.pdf")
 * @returns A File object constructed from the base64 string
 */
const base64ToFile = (base64String: string, fileName = "file-preview.pdf"): File => {
  // Decode base64 string into raw binary string
  const byteString = atob(base64String);

  // Convert binary string to Uint8Array
  const u8arr = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    u8arr[i] = byteString.charCodeAt(i);
  }

  // Construct File object with PDF MIME type
  return new File([u8arr], fileName, { type: "application/pdf" });
};

export default base64ToFile;
